import { Component, Input } from '@angular/core';

import { VtmnPlayIconTypeEnum } from '~/component/vtmn-play-icon/enums/vtmn-play-icon-type.enum';
import { EditionLinkInterface } from '~/organizer/activity-edition/interfaces/edition-link.interface';

@Component({
  selector: 'app-organizer-activity-edition-list',
  templateUrl: './edition-list.component.html',
})
export class OrganizerActivityEditionListComponent {
  @Input() public links: EditionLinkInterface[];
  @Input() public title?: string;

  public readonly iconType = VtmnPlayIconTypeEnum;
}
